import { create } from 'zustand';
import { ApiUtils, RequestStrategyEnum } from '@shared/utils';
import { ContentApi } from '@shared/api';

interface SiteTCStoreType {
  data: string;
  loading: boolean;
  error: string | null;
  get: (signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useSiteTCStore = create<SiteTCStoreType>((set) => ({
  data: '',
  loading: false,
  error: null,

  get: ApiUtils.wrapperApi(async (signal) => {
    try {
      set({ loading: true, error: null, data: '' });
      const result = await ContentApi.getSiteTC(signal);
      const decoder = new TextDecoder('utf-8');
      const htmlContent = decoder.decode(result?.data);
      set({ data: htmlContent ?? '', loading: false });
    } catch (error) {
      set({ error: ApiUtils.getApiError(error), loading: false });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ data: '', loading: false, error: null }),
}));
